export default {
  Epidemiology: {
    core: "Osnovna kompetencija: Primena epidemioloških principa (OIE 2.1) (obuhvata 3.3) frontline/intermediate/expert",
    definition:
      "Epidemiologija je proučavanje faktora koji određuju i utiču na učestalost i distribuciju bolesti ili drugih događaja vezanih za zdravlje i njihove uzroke u definisanoj populaciji u cilju kontrole njihovog razvoja i širenja i uspostavljanja programa za sprečavanje razvoja i širenja.",
    importance:
      "Kompetencije se definišu kao kombinacija znanja, veština i sposobnosti (OSA) koje proizvode 'merljivu ljudsku sposobnost koja je potrebna za efektivne performanse' (Marrelli, 2005).",
  },
};
